import React, { useContext, useState } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { FiMessageCircle, FiSend, FiX } from "react-icons/fi";

/**
 * Floating WhatsApp + Telegram dock, anchored bottom-end.
 * Uses contact.whatsapp / contact.telegram from the content JSON.
 * Stays clear of the existing scroll-to-top button (which sits at bottom-end).
 */
export default function FloatingContact() {
    const { data } = useContext(ContentContext);
    const [open, setOpen] = useState(false);
    const wa = data.contact.whatsapp || "";
    const tg = data.contact.telegram || "";
    const waUrl = `https://wa.me/${wa.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
        "Hello North Star LLC, I'd like to get in touch."
    )}`;
    const tgUrl = `https://t.me/${tg.replace(/^@/, "")}`;

    return (
        <div className="fixed bottom-6 start-6 z-50 flex flex-col items-start gap-3">
            {open && (
                <div className="flex flex-col gap-2 fade-in">
                    <a
                        href={waUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Chat on WhatsApp"
                        className="flex items-center gap-3 px-4 py-3 rounded-full bg-[#25D366] text-white font-semibold shadow-glow hover:brightness-110 transition"
                    >
                        <FiMessageCircle className="w-5 h-5" />
                        <span className="text-sm">WhatsApp</span>
                    </a>
                    <a
                        href={tgUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Chat on Telegram"
                        className="flex items-center gap-3 px-4 py-3 rounded-full bg-[#229ED9] text-white font-semibold shadow-glow hover:brightness-110 transition"
                    >
                        <FiSend className="w-5 h-5" />
                        <span className="text-sm">Telegram</span>
                    </a>
                </div>
            )}

            <button
                type="button"
                onClick={() => setOpen(!open)}
                aria-label={open ? "Close contact options" : "Open contact options"}
                aria-expanded={open}
                className="w-14 h-14 rounded-full gradient-emerald text-white shadow-glow flex items-center justify-center hover:brightness-110 transition"
            >
                {open ? <FiX className="w-6 h-6" /> : <FiMessageCircle className="w-6 h-6" />}
            </button>
        </div>
    );
}
